import {
  COMPANY_CREATE_REQUEST_FAIL,
  COMPANY_CREATE_REQUEST_SUCCESS,
  COMPANY_DELETE_REQUEST_FAIL,
  COMPANY_DELETE_REQUEST_SUCCESS,
  COMPANY_FIND_REQUEST_FAIL,
  COMPANY_FIND_REQUEST_SUCCESS,
  COMPANY_UPDATE_REQUEST_FAIL,
  COMPANY_UPDATE_REQUEST_SUCCESS,
  SELECT_COMPANY
} from '../action.types'
import initialState from '../initial.state'

export default function (state = initialState.company, action) {
  switch (action.type) {
    case COMPANY_CREATE_REQUEST_SUCCESS:
      return { ...action.payload }
    case COMPANY_CREATE_REQUEST_FAIL:
      return state
    case COMPANY_FIND_REQUEST_SUCCESS:
      return {
        ...action.payload
      }
    case COMPANY_FIND_REQUEST_FAIL:
      return state
    case COMPANY_UPDATE_REQUEST_SUCCESS:
      return state
    case COMPANY_UPDATE_REQUEST_FAIL:
      return state
    case COMPANY_DELETE_REQUEST_SUCCESS:
      return state
    case COMPANY_DELETE_REQUEST_FAIL:
      return state
    case SELECT_COMPANY:
      return {
        ...action.company
      }
    default:
      return state
  }
}

const convertComisstion = comission => {
  return comission ? comission * 100 : ''
}



// WEBPACK FOOTER //
// ./src/redux/company/company.reducer.js